import { useState } from 'react';
import { DbQueryEditor, DEFAULT_DB_CONNECTIONS, DEFAULT_SQL_DIALECT_DATA } from 'peak-editor-components';

interface DatabaseTabProps {
  data: any;
  onChange: (key: string, value: any) => void;
}

const COMMON_PROPS = {
    variables: { orderId: 1001, status: 'active' },
    variablesJson: JSON.stringify({ orderId: 1001, status: 'active' }, null, 2),
    onVariablesChange: () => {},
    variableError: null,
    functions: [],
    onFunctionsChange: () => {}
};

export const DatabaseTab: React.FC<DatabaseTabProps> = ({ data, onChange }) => {
  const [connections, setConnections] = useState(DEFAULT_DB_CONNECTIONS);
  const [executing, setExecuting] = useState(false);
  const [result, setResult] = useState<string | null>(null);

  const query = data.query || 'SELECT * FROM table WHERE id = {{ orderId }}';
  const connectionId = data.connectionId || '';
  const queryType = data.queryType || 'SELECT';
  const resultVariable = data.resultVariable || '';

  const handleQueryChange = (val: string) => onChange('query', val);
  const handleConfigChange = (key: string, val: string) => onChange(key, val);

  const handleExecute = () => {
      setExecuting(true);
      setTimeout(() => {
          setResult(JSON.stringify({ rowsAffected: 1, data: [{ id: 1, name: 'Test' }] }, null, 2));
          setExecuting(false);
      }, 1000);
  };

  return (
    <div className="flex flex-col h-full bg-slate-50">
      <div className="shrink-0 p-4 bg-white border-b border-slate-200 grid grid-cols-2 gap-4">
        <div>
            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Connection</label>
            <select
                className="w-full border border-slate-300 rounded p-1.5 text-sm outline-none focus:ring-2 focus:ring-emerald-500"
                value={connectionId}
                onChange={(e) => handleConfigChange('connectionId', e.target.value)}
            >
                <option value="">Select Connection...</option>
                {connections.map((c: any) => <option key={c.id} value={c.id}>{c.name} ({c.dialect})</option>)}
            </select>
        </div>
        <div>
            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Query Type</label>
            <select
                className="w-full border border-slate-300 rounded p-1.5 text-sm outline-none focus:ring-2 focus:ring-emerald-500"
                value={queryType}
                onChange={(e) => handleConfigChange('queryType', e.target.value)}
            >
                <option value="SELECT">Select</option>
                <option value="INSERT">Insert</option>
                <option value="UPDATE">Update</option>
                <option value="DELETE">Delete</option>
                <option value="PROCEDURE">Stored Procedure</option>
            </select>
        </div>
        <div className="col-span-2">
             <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Result Variable</label>
             <input
                type="text"
                className="w-full px-3 py-1.5 border border-slate-300 rounded text-sm outline-none focus:ring-2 focus:ring-emerald-500 font-mono"
                placeholder="dbResult"
                value={resultVariable}
                onChange={(e) => handleConfigChange('resultVariable', e.target.value)}
             />
        </div>
      </div>

      <div className="flex-1 relative border-t border-slate-200 min-h-[400px]">
        <DbQueryEditor
            content={query}
            onChange={handleQueryChange}
            connections={connections}
            activeConnectionId={connectionId || connections[0]?.id}
            onActiveConnectionChange={(id: string) => handleConfigChange('connectionId', id)}
            onUpdateConnections={setConnections}
            onExecuteQuery={handleExecute}
            isExecuting={executing}
            executionResult={result}
            onCancelQuery={() => setExecuting(false)}
            sqlLibrary={DEFAULT_SQL_DIALECT_DATA}
            {...COMMON_PROPS}
        />
      </div>
    </div>
  );
};
